/**
 * Status badge component for analysis
 * Shows color-coded status with icon
 */
function AnalysisStatusBadge({ status }) {
  const statusConfig = {
    configuring: {
      color: 'bg-gray-100 text-gray-800 border-gray-300',
      label: 'Configuring',
    },
    processing: {
      color: 'bg-blue-100 text-blue-800 border-blue-300',
      label: 'Processing',
      icon: '⏳',
    },
    awaiting_input: {
      color: 'bg-yellow-100 text-yellow-800 border-yellow-300',
      label: 'Needs Input',
      icon: '⚠️',
    },
    completed: {
      color: 'bg-green-100 text-green-800 border-green-300',
      label: 'Completed',
      icon: '✓',
    },
    failed: {
      color: 'bg-red-100 text-red-800 border-red-300',
      label: 'Failed',
      icon: '✗',
    },
  }

  const config = statusConfig[status] || statusConfig.configuring

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border ${config.color}`}
    >
      {config.icon && <span>{config.icon}</span>}
      {config.label}
    </span>
  )
}

export default AnalysisStatusBadge
